import {
  FETCH_STONES_REQUEST,
  FETCH_STONES_SUCCESS,
  FETCH_STONES_FAILURE,
  CREATE_STONE,
  UPDATE_STONE,
  DELETE_STONE,
} from '../../types/stone/stoneTypes';

const initialState = {
  stones: [],
  loading: false,
  error: null,
};

const stoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONES_REQUEST:
      return { ...state, loading: true };

    case FETCH_STONES_SUCCESS:
      return { ...state, loading: false, stones: action.payload };

    case FETCH_STONES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    
    case CREATE_STONE:
  return {
    ...state,
    stones: [...state.stones, action.payload],
  };

    case DELETE_STONE:
      return {
        ...state,
        stones: state.stones.filter((d) => d.id !== action.payload),
      };

    case UPDATE_STONE:
      return {
        ...state,
        stones: state.stones.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default stoneReducer;
